import { render, staticRenderFns } from "./PartyResourceRequests.vue?vue&type=template&id=7889b8bf"
import script from "./PartyResourceRequests.vue?vue&type=script&lang=js"
export * from "./PartyResourceRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports